// SPDX-License-Identifier: AGPL-3.0-or-later
import { useState } from "react";
import { api } from "../lib/api.js";
import { useI18n } from "../lib/i18n.js";

interface Props {
  mode: "oidc" | "dev" | "offline";
  notice: string | null;
  onDemo: () => void;
  onSignedIn: () => void;
}

export function SignIn({ mode, notice, onDemo, onSignedIn }: Props) {
  const { t } = useI18n();
  const [name, setName] = useState("");
  const [error, setError] = useState<string | null>(null);
  return (
    <div className="auth">
      <main className="card" id="main">
        <div className="brand" style={{ marginBottom: 12 }}>
          <img src="/icon.svg" alt="" />
          {t("app.name")}
        </div>
        <h1>{t("auth.signIn")}</h1>
        <p className="hint">{t("app.tagline")}</p>
        {notice && <p role="alert" className="form-error">{notice}</p>}
        <div className="stack" style={{ marginTop: 16 }}>
          {mode === "oidc" && (
            <>
              <p>{t("auth.signedOut")}</p>
              <a className="button primary" href={`/api/auth/login?returnTo=${encodeURIComponent(location.pathname + location.hash)}`}>
                {t("auth.signIn")}
              </a>
            </>
          )}
          {mode === "dev" && (
            <form
              className="stack"
              onSubmit={async (e) => {
                e.preventDefault();
                try {
                  await api.devLogin(name || "dev");
                  onSignedIn();
                } catch (err) {
                  setError((err as Error).message);
                }
              }}
            >
              <div className="field">
                <label htmlFor="dev-name">Development sign-in name</label>
                <input id="dev-name" type="text" value={name} onChange={(e) => setName(e.target.value)} autoComplete="username" />
                <p className="hint">Local development only. Production uses Authentik.</p>
              </div>
              {error && <p className="form-error">{error}</p>}
              <button className="primary" type="submit">
                {t("auth.signIn")}
              </button>
            </form>
          )}
          <button type="button" onClick={onDemo}>
            {t("auth.demo")}
          </button>
          <p className="hint">{t("auth.demoNote")}</p>
        </div>
      </main>
    </div>
  );
}
